import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, XIcon } from 'lucide-react';
import { careSteps, careDos, careDonts } from '../data/siteContent';
import { PageHero } from '../components/PageHero';
export function Care() {
  return <div className="w-full bg-paper" data-id="element-304" data-mp="26oi3imqtvv2m">
      <PageHero eyebrow="Care & use" title="Looked after, it lasts years." intro="An Ecoffee Cup® asks for about four things. None of them are difficult." data-id="element-305" data-mp="2bnkwv9xg4cur" />

      <section className="mx-auto max-w-[1400px] px-6 pb-28 pt-16 md:pt-24" data-id="element-306" data-mp="21pn9eoneuk37">
        <div className="grid gap-14 lg:grid-cols-[1.2fr_1fr] lg:gap-24" data-id="element-307" data-mp="21rrnu0ixr1hq">
          {/* Steps */}
          <ol className="space-y-10" data-id="element-308" data-mp="1nw5qn62jtbe8">
            {careSteps.map(s => <li key={s.step} className="flex gap-6 border-b border-oat/60 pb-10" data-id="element-309" data-mp="1sy4sgbin4092">
                <span className="type-display shrink-0 text-3xl text-oat" data-id="element-310" data-mp="1e2f4w8xt3f28">
                  {s.step}
                </span>
                <div data-id="element-311" data-mp="a2ayyzksaf8f">
                  <h2 className="type-display text-2xl text-coffee md:text-3xl" data-id="element-312" data-mp="a1hz8ik8spzs">
                    {s.title}
                  </h2>
                  <p className="type-body mt-3 max-w-xl text-sm text-ink/65" data-id="element-313" data-mp="53860di2vzgt">
                    {s.body}
                  </p>
                </div>
              </li>)}
          </ol>

          {/* Do / Don't */}
          <div className="space-y-6 lg:sticky lg:top-28 lg:self-start" data-id="element-314" data-mp="3nhh0ruqc8ppy">
            <div className="rounded-3xl border border-oat/70 bg-paper-warm px-8 pb-8 pt-10" data-id="element-315" data-mp="3nhpdnmmgnv15">
              <p className="type-eyebrow mb-7 text-[10px] text-forest" data-id="element-316" data-mp="3ik7fmr9zf07x">Do</p>
              <ul className="space-y-3" data-id="element-317" data-mp="56ldo507s38">
                {careDos.map(d => <li key={d} className="flex items-start gap-3" data-id="element-318" data-mp="3rissc5srvl0s">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" strokeWidth={2} data-id="element-319" data-mp="33tgmnfwnlv38" />
                    <span className="type-body text-sm text-ink/70" data-id="element-320" data-mp="2zrd98lqfcgfb">{d}</span>
                  </li>)}
              </ul>
            </div>
            <div className="rounded-3xl border border-oat/70 bg-paper-warm px-8 pb-8 pt-10" data-id="element-321" data-mp="17q26eg08jdp3">
              <p className="type-eyebrow mb-7 text-[10px] text-coffee" data-id="element-322" data-mp="1chbtp9yba4xt">
                Don’t
              </p>
              <ul className="space-y-3" data-id="element-323" data-mp="1hgocnjm2arv4">
                {careDonts.map(d => <li key={d} className="flex items-start gap-3" data-id="element-324" data-mp="jsmoayq83dg9">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" strokeWidth={2} data-id="element-325" data-mp="ju7mcybqxeiv" />
                    <span className="type-body text-sm text-ink/70" data-id="element-326" data-mp="tqassgdmrzbm">{d}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {/* Replacement parts */}
        <div className="mt-24 rounded-4xl bg-coffee px-10 pb-10 pt-12 text-paper md:px-14 md:pb-14 md:pt-16" data-id="element-327" data-mp="254xw4evsz3j3">
          <p className="type-eyebrow mb-6 text-[10px] text-paper/55" data-id="element-328" data-mp="2a398aw9klq4h">
            Replacement parts
          </p>
          <h2 className="type-display max-w-2xl text-3xl text-paper md:text-5xl" data-id="element-329" data-mp="3uoxpxm0lz58c">
            Lost a lid? Replace the lid, not the cup.
          </h2>
          <p className="type-body mt-6 max-w-xl text-base text-paper/70" data-id="element-330" data-mp="3kw9uauld77b7">
            Lids and sleeves are sold separately in every colourway we make.
            Ask your nearest stockist, or send us a note and we will post one.
          </p>
          <div className="mt-9 flex flex-wrap gap-3" data-id="element-331" data-mp="3awrdgn0r41nd">
            <Link to="/stockists" className="type-cta rounded-full bg-paper px-8 py-4 text-[11px] text-coffee transition-colors hover:bg-oat" data-id="element-332" data-mp="36x0per2lzzmj">
              Find a stockist
            </Link>
            <Link to="/contact" className="type-cta rounded-full border border-paper/30 px-8 py-4 text-[11px] text-paper transition-colors hover:bg-paper hover:text-coffee" data-id="element-333" data-mp="2x0xeowtoysnz">
              Contact us
            </Link>
          </div>
        </div>
      </section>
    </div>;
}